import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import * as siteActions from '../../actions/siteActions';
import * as systemActions from '../../actions/systemActions';
import * as reportActions from '../../actions/reportActions';
import systemsToSelectOptions from '../../utils/systemSelectFormatter';
import sitesToSelectOptions from '../../utils/siteSelectFormatter';
import MonthlyReportForm from './MonthlyReportForm';
import moment from 'moment';

class ReportsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      systems: props.systems,
      sites: props.sites,
      selectedSystem: '',
      selectedSite: '',
      selectedType: '',
      reportParams: {
        site: '',
        startDate: '',
        endDate: '',
      },
      errors: {},
      submitting: false,
      systemType: '',
      systemOptions: {},
    };
  }

  componentWillMount() {
    this.props.actions.loadSystems();
    this.props.actions.loadSites();
  }

  formIsValid() {
    const { reportParams, selectedType } = this.state;
    let errors = {};
    let isValid = true;

    if (selectedType === null || selectedType === '') {
      errors.type = 'Please select a report type';
      isValid = false;
    }

    if (reportParams.system === null || reportParams.system === '') {
      errors.system = 'Please select a system';
      isValid = false;
    }
    if (reportParams.site === null || reportParams.site === '') {
      errors.site = 'Please select a site';
      isValid = false;
    }

    if (reportParams.startDate === null || reportParams.startDate === '') {
      errors.startDate = 'Select a start date.';
      isValid = false;
    }
    if (reportParams.endDate === null || reportParams.endDate === '') {
      errors.endDate = 'Select an end date.';
      isValid = false;
    }
    this.setState({ errors: errors });
    return isValid;
  }

  handleSystemChange = (selectedOption) => {
    const sitesForSystem = this.props.sites.filter(
      (site) => site.systemId === selectedOption.value
    );
    const system = this.props.systems.filter(
      (system) => system.id === selectedOption.value
    );
    const siteOptions = sitesToSelectOptions(sitesForSystem);
    this.setState({
      sites: siteOptions,
      selectedSystem: selectedOption,
      systemType: system[0].systemType,
    });
  };

  handleSiteChange = (selectedOption) => {
    this.setState({ selectedSite: selectedOption });
    const paramToUpdate = Object.assign({}, this.state.reportParams);
    paramToUpdate.site = selectedOption;
    this.setState({
      selectedSite: selectedOption,
      reportParams: paramToUpdate,
    });
  };

  handleTypeChange = (selectedOption) => {
    this.setState({ selectedType: selectedOption });
  };

  handleClick = (event) => {
    event.preventDefault();
    if (!this.formIsValid()) return;
    const { site, startDate, endDate } = this.state.reportParams;
    const { selectedSystem, selectedSite, selectedType } = this.state;
    const month = moment(startDate).local().format('MMMM_YYYY');
    const name = selectedSystem.label + '_' + selectedSite.label;
    const fileName = name + '_' + month;

    if (selectedType.value === 'Reading') {
      if (this.state.systemType === 'Water')
        this.props.actions.generateSiteMorByMonth(
          site.value,
          startDate,
          endDate,
          fileName + '.pdf'
        );
      else if (this.state.systemType === 'Waste')
        this.props.actions.generateSiteDNRbyMonth(
          site.value,
          startDate,
          endDate,
          fileName + '.xls'
        );
    } else if (selectedType.value === 'Billing') {
      this.props.actions.generateSiteBillingReportByMonth(
        site.value,
        startDate,
        endDate,
        fileName + '.xls'
      );
    } else {
      return;
    }
  };

  onChange = (event) => {
    const field = event.target.id;
    const paramToUpdate = Object.assign({}, this.state.reportParams);
    paramToUpdate[field] = event.target.value;
    this.setState({ reportParams: paramToUpdate });
  };

  render() {
    const {
      selectedSystem,
      selectedType,
      selectedSite,
      reportParams,
      errors,
      submitting,
      sites,
    } = this.state;
    const typeOptions = [
      {
        value: 'Reading',
        label: 'Reading',
      },
      {
        value: 'Billing',
        label: 'Billing',
      },
    ];
    return (
      <div>
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <h1 className="text-center mt-4">Reports</h1>
            </Col>
          </Row>
        </Container>
        <MonthlyReportForm
          reportParams={reportParams}
          systems={this.props.systemOptions}
          sites={sites}
          onChange={this.onChange}
          onSubmit={this.handleClick}
          submitting={submitting}
          errors={errors}
          selectedSystem={selectedSystem}
          selectedSite={selectedSite}
          onSystemChange={this.handleSystemChange}
          onSiteChange={this.handleSiteChange}
          onTypeChange={this.handleTypeChange}
          selectedType={selectedType}
          typeOptions={typeOptions}
        />
      </div>
    );
  }
}

ReportsPage.propTypes = {
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const filtered = state.systems.filter((s) => s.isActive);
  const systemOptions = systemsToSelectOptions(filtered);
  return {
    systems: state.systems,
    sites: state.sites,
    systemOptions: systemOptions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...siteActions, ...systemActions, ...reportActions },
      dispatch
    ),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReportsPage)
);



// WEBPACK FOOTER //
// ./src/components/reports/ReportsPage.js